import axios from 'axios'

const RESOURCE_NAME = '/roles'

export default {
  getAll () {
    return axios.get(`${RESOURCE_NAME}`)
  },

  get (id) {
    return axios.get(`${RESOURCE_NAME}/${id}`)
  },

  update (id, data) {
    return axios.put(`${RESOURCE_NAME}/${id}`, data)
  },

  getAllPermissions () {
    return axios.get(`/permissions`)
  },

  create (data) {
    return axios.post(`${RESOURCE_NAME}`, data)
  }
}
